import React, {Component} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {Button, Card, DatePicker, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request, { API_URL } from '../../request'
import moment from 'moment'
import _ from 'lodash'

import {RightsWrapper} from '../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllEmailSettings extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    docObject:{},
    mailerSendApi:false
  }
  handleSubmit = e => {
    const {dispatch, form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = await Request.addCommunicationSettings(values)

        if (!x.error) {
          notification.success({
            message: `Setting Updated Successfully`
          })
          this.getCommunicationSettings()
        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  getCommunicationSettings() {
      Request.getCommunicationSettings().then(
        ({doc, error, message}) => {
          console.log(doc)
          if (!error && doc) {          
            if(doc.mailerSendApi) {
              this.setState({mailerSendApi:doc.mailerSendApi})
            }  
            this.props.form.setFieldsValue({
                emailApiUrl:doc.emailApiUrl,
                emailApiKey:doc.emailApiKey,
                emailDomainId:doc.emailDomainId,
                companyEmail:doc.companyEmail,
                mailerSendApi:doc.mailerSendApi,
                smtpProvider: doc.smtpProvider,
                smtpPort: doc.smtpPort,
                smtpUsername: doc.smtpUsername,
                smtpPassword: doc.smtpPassword,
                companyName:doc.companyName,
                fromEmail:doc.fromEmail,
                replyTo:doc.replyTo,
                noReplyTo: doc.noReplyTo,
                financeSmtpProvider:doc.financeSmtpProvider,
                financeSmtpPort:doc.financeSmtpPort,
                financeSmtpUsername:doc.financeSmtpUsername,
                financeSmtpPassword:doc.financeSmtpPassword,
                financeCompanyName:doc.financeCompanyName,
                financeFromEmail:doc.financeFromEmail,
                financeReplyTo:doc.financeReplyTo
            })
            this.setState({docObject: doc});
          } else {
            // notification.error({
            //   message: 'Error Getting Data',
            //   description: message
            // })
          }
        }
      )
  }

  componentWillMount() {
    this.getCommunicationSettings()
  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
  }
  chooseTab(value) {    
    this.setState({
        activeTab: value
    });
    let doc = this.state.docObject;
    setTimeout(() => {
        this.props.form.setFieldsValue({
            smtpProvider: doc.smtpProvider,
            smtpPort: doc.smtpPort,
            smtpUsername: doc.smtpUsername,
            smtpPassword: doc.smtpPassword,
            companyName:doc.companyName,
            fromEmail:doc.fromEmail,
            replyTo:doc.replyTo,
            noReplyTo: doc.noReplyTo,
            financeSmtpProvider:doc.financeSmtpProvider,
            financeSmtpPort:doc.financeSmtpPort,
            financeSmtpUsername:doc.financeSmtpUsername,
            financeSmtpPassword:doc.financeSmtpPassword,
            financeCompanyName:doc.financeCompanyName,
            financeFromEmail:doc.financeFromEmail,
            financeReplyTo:doc.financeReplyTo,
            
        })
    }, 1000)
  }
  render() {
    const {dispatch} = this.props
    const {
      form: {getFieldDecorator, setFieldsValue}
    } = this.props
    const {id} = this.state;

    const financeEmailSettingInputTypes = {
      fields:[
        {
          label: 'SMTP Provider',
          key: 'financeSmtpProvider',
          hidden:this.state.mailerSendApi
        },
        {
          label: 'SMTP Port',
          key: 'financeSmtpPort',
          hidden:this.state.mailerSendApi
        },
        {
          label: 'SMTP Username',
          key: 'financeSmtpUsername',
          hidden:this.state.mailerSendApi
        },
        {
          label: 'SMTP Password',
          key: 'financeSmtpPassword',
          hidden:this.state.mailerSendApi
        },
        {
          label: 'Company Name',
          key: 'financeCompanyName',
          required:this.state.mailerSendApi
        },
        {
          label:'From Email',
          key:'financeFromEmail',
          required:this.state.mailerSendApi
        },
        {
          label:'Reply To Email',
          key:'financeReplyTo',
          hidden:this.state.mailerSendApi
        },
      ]
    }

    const emailSettingInputTypes = {
      fields: [
        {
          label:'Mailersend API',
          key:'mailerSendApi',
          default:this.state.mailerSendApi,
          type:'switch',
          onChange:v=>{
            this.setState({mailerSendApi:v})
            setFieldsValue({mailerSendApi:v})
          }
        },
        {
          label:'API URL',
          key:'emailApiUrl',
          hidden:!this.state.mailerSendApi,
          required:this.state.mailerSendApi
        },
        {
          label:'API Key',
          key:'emailApiKey',
          hidden:!this.state.mailerSendApi,
          required:this.state.mailerSendApi
        },
        {
          label:'Domain Id',
          key:'emailDomainId',
          hidden:!this.state.mailerSendApi,
          required:this.state.mailerSendApi
        },
        {
          label: 'SMTP Provider',
          key: 'smtpProvider',
          hidden:this.state.mailerSendApi
        },
        {
          label: 'SMTP Port',
          key: 'smtpPort',
          hidden:this.state.mailerSendApi
        },
        {
          label: 'SMTP Username',
          key: 'smtpUsername',
          hidden:this.state.mailerSendApi
        },
        {
          label: 'SMTP Password',
          key: 'smtpPassword',
          hidden:this.state.mailerSendApi
        },
        {
          label:'Company Email',
          key:'companyEmail',
          hidden:!this.state.mailerSendApi,
          required:this.state.mailerSendApi
        },
        {
          label: 'Company Name',
          key: 'companyName',
          required:this.state.mailerSendApi
        },
        {
          label:'From Email',
          key:'fromEmail',
          required:this.state.mailerSendApi
        },
        {
          label:'Reply To Email',
          key:'replyTo',
          hidden:this.state.mailerSendApi
        },
        {
          label:'No Reply Email',
          key:'noReplyTo',
          hidden:this.state.mailerSendApi
        },
        {
          label:'Email Header Logo',
          key:'emailHeaderLogo',
          type:'file'
        },
        {
          label:'Email Footer Logo',
          key:'emailFooterLogo',
          type:'file'
        }
      ]
    };

    return (
        <PageHeaderWrapper title={` Communication Settings `}>
            <Card bordered={true}>
                <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
                    <TabPane tab={`Email Setting`} key={0}>
                        <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                            <GetAllFormFields
                                inputSchema={emailSettingInputTypes}
                                refresh={this.refreshFxn}
                                getFieldDecorator={getFieldDecorator}
                                apiurl={API_URL}
                                />
                            <Button
                                type=""
                                htmlType="submit"
                                style={{
                                marginBottom: 10,
                                marginLeft: '33%',
                                backgroundColor: 'green',
                                color: 'white'
                                }}
                                loading={this.props.loading}
                            >
                                SAVE
                            </Button>
                            <Button
                                type="primary"
                                style={{marginBottom: 10, marginLeft: '1%'}}
                                loading={this.props.loading}
                                onClick={() => {
                                this.props.form.resetFields()
                            }}>
                                RESET
                            </Button>
                        </Form>
                    </TabPane>
                    <TabPane tab={`Finance Email Setting`} key={1}>
                    <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                            <GetAllFormFields
                                inputSchema={financeEmailSettingInputTypes}
                                refresh={this.refreshFxn}
                                getFieldDecorator={getFieldDecorator}
                                apiurl={API_URL}
                                />
                            <Button
                                type=""
                                htmlType="submit"
                                style={{
                                marginBottom: 10,
                                marginLeft: '33%',
                                backgroundColor: 'green',
                                color: 'white'
                                }}
                                loading={this.props.loading}
                            >
                                SAVE
                            </Button>
                            <Button
                                type="primary"
                                style={{marginBottom: 10, marginLeft: '1%'}}
                                loading={this.props.loading}
                                onClick={() => {
                                this.props.form.resetFields()
                            }}>
                                RESET
                            </Button>
                        </Form>
                    </TabPane>
                </Tabs>
            </Card>
        </PageHeaderWrapper>
    );
  }
}

export default AllEmailSettings
